<div class="date-picker-modal">
  <div class="modal-header">
    <h2 mat-dialog-title>{{ title }}</h2>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-content" mat-dialog-content>
    <bhub-date-picker
      [label]="title"
      [(ngModel)]="value"
      (dateChange)="onDateChange($event)"
      [required]="required"
      [minDate]="minDate"
      [maxDate]="maxDate">
    </bhub-date-picker>
  </div>

  <div class="modal-actions" mat-dialog-actions>
    <button mat-button (click)="onCancel()">
      Cancel
    </button>
    <button mat-raised-button
            color="primary"
            (click)="onConfirm()"
            [disabled]="!isValid()">
      Confirm
    </button>
  </div>
</div>
